import { Directive, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core'
import { TableScrollService, TableScrollState } from '../services/table-scroll.service'

@Directive({
  selector: '[llaTableScrollNavigation]',
  standalone: true
})
export class TableScrollNavigationDirective implements OnInit, OnDestroy {
  @Input() debounceMs = 100
  @Output() scrollStateChanged = new EventEmitter<TableScrollState>()

  private containerId: string

  constructor(
    private elementRef: ElementRef<HTMLElement>,
    private tableScrollService: TableScrollService
  ) {
    // Generate a unique ID if the element doesn't have one
    this.containerId =
      this.elementRef.nativeElement.id || `table-scroll-${Math.random().toString(36).substr(2, 9)}`
    if (!this.elementRef.nativeElement.id) {
      this.elementRef.nativeElement.id = this.containerId
    }
  }

  ngOnInit(): void {
    this.tableScrollService.setupScrollListener(
      this.containerId,
      (state: TableScrollState) => {
        this.scrollStateChanged.emit(state)
      },
      this.debounceMs
    )
  }

  ngOnDestroy(): void {
    this.tableScrollService.removeScrollListener(this.containerId)
  }

  /**
   * Scroll to the left side of the table
   */
  public scrollToLeft(smooth = true): void {
    this.tableScrollService.scrollToLeft(this.containerId, smooth)
  }

  /**
   * Scroll to the right side of the table
   */
  public scrollToRight(smooth = true): void {
    this.tableScrollService.scrollToRight(this.containerId, smooth)
  }

  /**
   * Scroll to a specific position
   */
  scrollToPosition(scrollLeft: number, smooth = true): void {
    this.tableScrollService.scrollToPosition(this.containerId, scrollLeft, smooth)
  }

  /**
   * Get current scroll state
   */
  getScrollState(): TableScrollState {
    return this.tableScrollService.getScrollState(this.containerId)
  }

  /**
   * Check if the table has horizontal scroll
   */
  hasHorizontalScroll(): boolean {
    return this.tableScrollService.hasHorizontalScroll(this.containerId)
  }
}
